import DishesNearMe from "../components/dishes-near-me";

export default {
  name: "Dishes near me",
  component: DishesNearMe,
  url: "/dishes",
  exact: true,
  requireAuth: true
};
